'use client'
/* eslint-disable react/no-unescaped-entities */

import { useEffect } from 'react'
import { Header } from '@/app/components/common/Header'
import { Button } from '@/app/components/common/Button'
import { Card } from '@/app/components/common/Card'
import { logError } from '@/lib/logging'

export default function BookingPageError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    logError('Booking page error:', error)
  }, [error])

  return (
    <div data-component-name="BookingPageError" className="min-h-screen bg-gray-50">
      <div className="bg-white shadow-sm mb-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Header level={2}>Book Your Free Consultation</Header>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
        <Card>
          <div className="p-8 text-center">
            <Header className="mb-4">Something went wrong</Header>
            <p className="text-gray-600 mb-6">
              We're having trouble loading this booking page. Please try again.
            </p>
            <Button onClick={reset}>Try Again</Button>
          </div>
        </Card>
      </div>
    </div>
  )
}
